import AbstractService from '@/services/abstractService'

class PortfolioService extends AbstractService {
    endpoint = 'portfolios'

    index() {
      return this.http.get(this.endpoint, { params: { dashboard: true } })
    }

    post(data) {
      // define append form
      const formData = new FormData()
      for (const key in data) {
        if (key === 'projectGallery') {
          for (const index in data[key]) {
            formData.append(`${key}[${index}]`, data[key][index])
          }
        } else {
          formData.append(key, data[key])
        }
      }
      return this.http.post(this.endpoint, formData)
    }

    put(data) {
      // define append form
      const formData = new FormData()
      for (const key in data) {
        if (key === 'uploaded') {
          console.log(data[key])
          if (data[key].length === 0) formData.append(`${key}[]`, [])
          for (const index in data[key]) {
            formData.append(`${key}[${index}]`, data[key][index])
          }
        } else if (key === 'remained') {
          if (data[key].length === 0) formData.append(`${key}[]`, [])
          for (const index in data[key]) {
            formData.append(`${key}[${index}]`, data[key][index])
          }
        } else {
          formData.append(key, data[key])
        }
      }
      return this.http.put(`${this.endpoint}/${data.id}`, formData)
    }

    delete(data) {
      console.log('data', data)
      return this.http.delete(`${this.endpoint}/${data}`)
    }
}

const Service = new PortfolioService()

export default Service
